  import './ShowLessonsFinanciara.css'
  import './Showlessonsmodel.css';
  import '../home.css';
  import { useState, useEffect, useRef } from 'react';
  import certificate from '../../header/images/certificate.png'
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
  import { faGraduationCap, faFlagCheckered, faPuzzlePiece, faArrowUp, faArrowDown, faFileLines, faBookOpen, faShareNodes, faDumbbell, faForwardFast, faPlay } from '@fortawesome/free-solid-svg-icons';
  import { useNavigate, useLocation, Link } from 'react-router-dom';
  import contafinanciara from '../../imagesHome/contafinanciara.png';
  import safebadge from '../../imagesHome/safe_case.png';
    import brainreview from '../../imagesHome/brain_review.png';
    import chaptericon from '../../imagesHome/chapter_icon.png';
     import trophy from '../../imagesHome/trophy.png';
      import road from '../../imagesHome/road.png';
       import finish from '../../imagesHome/finish.png';
        import diploma from '../../imagesHome/progress-card.png';

      

  
  import { FloatingLessonBubbleCf } from '../lessonstyles/FloatingLessonBubbleCf';
    import { FloatingLessonBubbleJump} from '../lessonstyles/FloatingLessonBubbleJump';



  import LessonSeparator from '../lessonstyles/LessonSeparator';

 import GetProCard from './rightelements/GetProCard';
 import LeaderboardCard from './rightelements/LeaderboardCard';
 import DailyGoalsCard from './rightelements/DailyGoalsCard';
 import FooterElements from './rightelements/FooterElements';
 import SocialElements from './rightelements/SocialElements';
 import StatsCard from './popupsright/StatsCard';





  export const ShowLessonsFinanciara = () => {
    const [showLessonsMain, setShowLessonsMain] = useState(true);
    
    const [activePanel, setActivePanel] = useState(null);


    const getPanelKey = (chapter, lessonId) => `chapter-${chapter}-lesson-${lessonId}`;

const [floatingLesson, setFloatingLesson] = useState(null);

const scrollerRef = useRef(null);


const [showInitialFloating, setShowInitialFloating] = useState(false);

const floatingPanelWrapperRef = useRef(null);
const skipNextScrollClose = useRef(false);
const isUserScrolling = useRef(false);

const scrollProtectorRef = useRef(false);
const [isActiveLessonVisible, setIsActiveLessonVisible] = useState(true);
const [scrollDirectionUp, setScrollDirectionUp] = useState(false);
const congratsRef = useRef(null);
const [hideScrollButton, setHideScrollButton] = useState(false);
const [loadingLesson, setLoadingLesson] = useState(false);







const [isDesktop, setIsDesktop] = useState(() =>
  typeof window !== 'undefined' && window.matchMedia('(min-width: 1121px)').matches
);

useEffect(() => {
  const mql = window.matchMedia('(min-width: 1121px)');
  const onChange = (e) => setIsDesktop(e.matches);
  mql.addEventListener?.('change', onChange);
  return () => mql.removeEventListener?.('change', onChange);
}, []);

const prevLessonRef = useRef(null);









useEffect(() => {
  const html = document.documentElement;
  const body = document.body;

  html.classList.add('showlessons-active');
  body.classList.add('showlessons-active');

  return () => {
    html.classList.remove('showlessons-active');
    body.classList.remove('showlessons-active');
  };
}, []);







const lessonRefs = useRef({});                  




useEffect(() => {
  const updateColumnPosition = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    document.documentElement.style.setProperty('--lesson-column-left', `${rect.left}px`);
  };

  updateColumnPosition();
  window.addEventListener('resize', updateColumnPosition);
  window.addEventListener('scroll', updateColumnPosition, { passive: true });

  return () => {
    window.removeEventListener('resize', updateColumnPosition);
    window.removeEventListener('scroll', updateColumnPosition);
  };
}, []);



useEffect(() => {
  const el = scrollerRef.current;
  if (!el) return;

  const setVars = () => {
    const r = el.getBoundingClientRect();
    const root = document.documentElement.style;
    root.setProperty('--lesson-col-left', `${r.left}px`);
    root.setProperty('--lesson-col-right', `${window.innerWidth - r.right}px`);
    root.setProperty('--lesson-col-width', `${r.width}px`);
  };

  setVars();

  // ținem valorile la zi când se schimbă layoutul
  const ro = new ResizeObserver(setVars);
  ro.observe(el);

  window.addEventListener('resize', setVars);
  window.addEventListener('scroll', setVars, { passive: true });

  return () => {
    ro.disconnect();
    window.removeEventListener('resize', setVars);
    window.removeEventListener('scroll', setVars);
  };
}, []);



    const panelRef = useRef(null);
    const lessonButtonRef = useRef(null);

    const unhideLessons = () => setShowLessonsMain(!showLessonsMain);

    const [chapters, setChapters] = useState([]);
    
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageLoading, setPageLoading] = useState(true);

    

    const location = useLocation();
    const { updatedProgress } = location.state || {};

    const tothelesson = useNavigate();

    const [lessonProgress, setLessonProgress] = useState({});

    

    const [activeChapters, setActiveChapters] = useState({});

const justClosedRef = useRef(false);
    

    const getLessonStatus = (chapterId, lessonId) => {
      const key = `${chapterId}-${lessonId}`;
      const status = lessonProgress[key];
    
      if (!status || !status.unlocked) return 'locked';
      if (status.completed) return 'completed';
      return 'unlocked';
    };
    
    


    

    //cere titlul
useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/chapters/titles`, {
    credentials: 'include'
  })
    .then(res => res.json())
    .then(data => {
      setTitles(data);
      setLoading(false);
    })
    .catch(err => {
      console.error('Eroare la fetch titluri:', err);
      setLoading(false);
    });
}, []);




// cere lectiile
useEffect(() => {
  fetch(`${process.env.REACT_APP_API_URL}/contafinanciara`, {
    credentials: 'include'
  })
    .then(res => res.json())
    .then(data => {
      setChapters(data.chapters);

      const activeByDefault = {};
      const progressUnlocked = {};

      data.chapters.forEach((chapter, chapterIndex) => {
        activeByDefault[chapterIndex] = true;

        chapter.lessons.forEach((lesson, lessonIndex) => {
          const key = `${chapter.id}-${lesson.lesson}`;
          const isFirstLesson = chapterIndex === 0 && lessonIndex === 0;
          const isJumpHere = lesson.explanationType?.toLowerCase() === 'jumphere';

          progressUnlocked[key] = {
            unlocked: isFirstLesson || isJumpHere,
            completed: false,
          };
        });
      });

      setActiveChapters(activeByDefault);
      setLessonProgress(progressUnlocked);
    })
    .catch(err => {
      console.error('Eroare la fetch capitole:', err);
    });
}, []);

useEffect(() => {
  if (!loading && chapters.length > 0) {
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }
}, [loading, chapters]);




    
    useEffect(() => {
      if (updatedProgress) {
        setLessonProgress(prevProgress => ({
          ...prevProgress,
          ...updatedProgress,
        }));
      }
    }, [updatedProgress]);



    //aici se cer lectiile
  const handleLessonClick = async (chapterId, lessonId) => {
  const key = `${chapterId}-${lessonId}`;

  setLoadingLesson(true);

  try {
     const response = await fetch(`${process.env.REACT_APP_API_URL}/contafinanciara/${chapterId}/lesson/${lessonId}`, {
      credentials: 'include'
    });

    let lessonData = {};

    if (response.ok) {
      lessonData = await response.json();
    } else {
      console.warn("Lecția nu a fost găsită pe server. Se deschide o lecție fallback.");
      lessonData = {
        title: "Lecție indisponibilă",
        content: "Această lecție nu este încă disponibilă. Te rugăm să revii mai târziu."
      };
    }

    tothelesson('/chaptercontainercf', {
      state: { chapterId, lessonId, lessonData }
    });

  } catch (error) {
    console.error("Eroare de rețea:", error);

    const lessonData = {
      title: "Eroare de rețea",
      content: "Nu am putut încărca lecția. Verifică conexiunea la internet și încearcă din nou."
    };

    tothelesson('/chaptercontainercf', {
      state: { chapterId, lessonId, lessonData }
    });
  }
  finally {
    setLoadingLesson(false);
  }
};

    
    

    const togglePanel = (chapterId, lessonId, event) => {
    const panelKey = getPanelKey(chapterId, lessonId);
    setActivePanel(prevPanel => (prevPanel === panelKey ? null : panelKey));
    lessonButtonRef.current = event.currentTarget;

    setTimeout(() => {
      if (panelRef.current && panelKey !== activePanel) {
        panelRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, 100);
  };


    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          panelRef.current && !panelRef.current.contains(event.target) &&
          lessonButtonRef.current && !lessonButtonRef.current.contains(event.target)
        ) {
          setActivePanel(null);
        }
      };

      if (activePanel !== null) {
        document.addEventListener('mousedown', handleClickOutside);
      }
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [activePanel]);



useEffect(() => {
  const mql = window.matchMedia('(max-width: 1120px)');
  const header = document.querySelector('.headerbc');
  const scroller = scrollerRef.current || null;

  let io;

  const setup = () => {
    if (io) { io.disconnect(); io = undefined; }
    if (!header) return;

    if (!mql.matches) {
      header.classList.remove('headerbc--hide-left');
      return;
    }

    const firstModule = document.querySelector('.general-framework-bc-mobile');
    if (!firstModule) return;

    const headerH = (header.offsetHeight || 64) + 6;

    io = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        if (e.isIntersecting) {
          header.classList.remove('headerbc--hide-left');
        } else {
          header.classList.add('headerbc--hide-left');
        }
      },
      {
        root: scroller,
        rootMargin: `-${headerH}px 0px 0px 0px`,
        threshold: 0,
      }
    );

    io.observe(firstModule);
  };

  setup();
  const onChange = () => setup();
  mql.addEventListener?.('change', onChange);
  window.addEventListener('resize', onChange);

  return () => {
    if (io) io.disconnect();
    mql.removeEventListener?.('change', onChange);
    window.removeEventListener('resize', onChange);
  };
}, [chapters]);



useEffect(() => {
  const header = document.querySelector('.headerbc');
  if (!header) return;

  const observer = new MutationObserver(() => {
    if (header.classList.contains('headerbc--hide-left')) {
      setShowInitialFloating(true); // 👈 activează butonul
    } else {
      setShowInitialFloating(false); // 👈 opțional: ascunde când revine meniul
    }
  });

  observer.observe(header, { attributes: true, attributeFilter: ['class'] });

  return () => observer.disconnect();
}, []);



// click în afara panelului → închide
useEffect(() => {
  const handleClickOutside = (event) => {
    if (panelRef.current && !panelRef.current.contains(event.target)) {
      setFloatingLesson(null);
    }
  };

  if (floatingLesson) {
    document.addEventListener('mousedown', handleClickOutside);
  }
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [floatingLesson]);

// scroll → închide panelul
useEffect(() => {
  const handleScroll = () => {
    if (
      floatingLesson &&
      !skipNextScrollClose.current &&
      isUserScrolling.current &&
      !scrollProtectorRef.current // protejează când comuți lecția
    ) {
      setFloatingLesson(null);
    }
  };

  const el = scrollerRef.current || window;
  el.addEventListener('scroll', handleScroll, { passive: true });

  return () => {
    el.removeEventListener('scroll', handleScroll);
  };
}, [floatingLesson]);




useEffect(() => {
  if (!floatingLesson) return;

  const lessonKey = `${floatingLesson.chapterId}-${floatingLesson.lessonId}`;
  const lessonEl = lessonRefs.current[lessonKey];

  if (lessonEl) {
    skipNextScrollClose.current = true;
    isUserScrolling.current = false;

    // ⚠️ Găsim containerul scrollabil
    const scrollableContainer = document.querySelector('.line-lesson-gackground');

    if (scrollableContainer) {
      const containerRect = scrollableContainer.getBoundingClientRect();
      const lessonRect = lessonEl.getBoundingClientRect();

      const offsetTop = lessonRect.top - containerRect.top;
      const centeredScroll = offsetTop + scrollableContainer.scrollTop - scrollableContainer.clientHeight / 2 + lessonRect.height / 2;

      scrollableContainer.scrollTo({
        top: centeredScroll,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      skipNextScrollClose.current = false;
    }, 500);
  }
}, [floatingLesson]);



useEffect(() => {
  if (justClosedRef.current) {
    const timeout = setTimeout(() => {
      justClosedRef.current = false;
    }, 300); // delay suficient

    return () => clearTimeout(timeout);
  }
}, [floatingLesson]);




useEffect(() => {
  const handleClickOutside = (event) => {
  setTimeout(() => {
    if (
      floatingPanelWrapperRef.current &&
      !floatingPanelWrapperRef.current.contains(event.target)
    ) {
      setFloatingLesson(null);
    }
  }, 0);
};

  if (floatingLesson) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [floatingLesson]);





useEffect(() => {
  const handleUserScroll = () => {
    isUserScrolling.current = true;
  };

  window.addEventListener('wheel', handleUserScroll, { passive: true });
  window.addEventListener('touchmove', handleUserScroll, { passive: true });

  return () => {
    window.removeEventListener('wheel', handleUserScroll);
    window.removeEventListener('touchmove', handleUserScroll);
  };
}, []);


useEffect(() => {
  if (!floatingLesson) {
    isUserScrolling.current = false;
  }
}, [floatingLesson]);


    const getLessonIconColor = (status) => {
      switch (status) {
        case 'locked':
          return '#9ca3af'; // gri
        case 'unlocked':
          return '#9ca3af'; // gri
        case 'completed':
          return '#22c55e'; // verde
        default:
          return '#10b981'; // fallback: mentă
      }
    };
    

const getFirstAvailableLessonKey = () => {
  for (const key in lessonProgress) {
    const status = lessonProgress[key];
    if (status.unlocked && !status.completed) {
      return key;
    }
  }
  return null;
};

const [firstAvailableLessonKey, setFirstAvailableLessonKey] = useState(null);

useEffect(() => {
  if (!Object.keys(lessonProgress).length) return;

  const firstKey = Object.entries(lessonProgress).find(
    ([, status]) => status?.unlocked && !status?.completed
  );

  if (firstKey) {
    setFirstAvailableLessonKey(firstKey[0]);
  }
}, [lessonProgress]);




useEffect(() => {
  if (!justClosedRef.current) return;

  const timer = setTimeout(() => {
    justClosedRef.current = false;
  }, 300);

  return () => clearTimeout(timer);
}, [justClosedRef.current]);


useEffect(() => {
  if (floatingLesson === null) {
    const timer = setTimeout(() => {
      justClosedRef.current = false;
    }, 300);

    return () => clearTimeout(timer);
  }
}, [floatingLesson]);




useEffect(() => {
  const key = firstAvailableLessonKey;
  const lessonEl = lessonRefs.current[key];
  const scroller = scrollerRef.current;

  if (!key || !lessonEl || !scroller) return;

  const updatePosition = () => {
    const lessonRect = lessonEl.getBoundingClientRect();
    const buttonEl = document.querySelector('.scroll-to-active-lesson-fixed');

    // ✅ Determină dacă lecția e vizibilă
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isVisible =
      lessonRect.top >= 0 &&
      lessonRect.bottom <= windowHeight;

    setIsActiveLessonVisible(isVisible);

    // ✅ Determină direcția
    if (buttonEl) {
      const buttonTop = buttonEl.getBoundingClientRect().top;
      setScrollDirectionUp(lessonRect.top < buttonTop); // 🧠 dacă lecția e mai sus decât butonul, arătăm în sus
    }
  };

  // ✅ Rulează inițial (după un frame)
  const raf = requestAnimationFrame(updatePosition);

  // ✅ Rulează la scroll
  const onScroll = () => {
    updatePosition();
  };

  const scrollContainer = scrollerRef.current || window;
  scrollContainer.addEventListener('scroll', onScroll, { passive: true });

  return () => {
    cancelAnimationFrame(raf);
    scrollContainer.removeEventListener('scroll', onScroll);
  };
}, [firstAvailableLessonKey]);



useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      setHideScrollButton(entry.isIntersecting);
    },
    {
      root: null, // se uită în viewport-ul paginii
      threshold: 0.1,
    }
  );

  if (congratsRef.current) {
    observer.observe(congratsRef.current);
  }

  return () => {
    if (congratsRef.current) {
      observer.unobserve(congratsRef.current);
    }
  };
}, []);






    const getLessonLeftIconColor = (lesson) => {
      const type = lesson.explanationType || lesson.title;
    
      if (type.toLowerCase().includes('practica')) return 'rgba(255, 255, 255, 1)';
      if (type.toLowerCase().includes('aplicatie')) return '#ffffffff';
      if (type.toLowerCase().includes('lectie')) return '#ffffffff';
      if (type.toLowerCase().includes('introducere')) return '#ffffffff';
      if (type.toLowerCase().includes('avanseaza')) return '#ffffffff';
      if (type.toLowerCase().includes('jumphere')) return '#ffffffff';
      if (type.toLowerCase().includes('safebadge')) return '#ffffffff';
      if (type.toLowerCase().includes('recapitulare')) return '#ffffffff';
      if (type.toLowerCase().includes('recapitulation')) return '#ffffffff';

      


      if (type.toLowerCase().includes('test')) return 'rgba(255, 255, 255, 1)';
      return '#10b981';
    };
    
    
    const getLessonLeftIcon = (lesson) => {
      const type = lesson.explanationType?.toLowerCase() || lesson.title?.toLowerCase();
    
      if (type.includes('practica')) return faDumbbell;
      if (type.includes('aplicatie')) return faPuzzlePiece;
      if (type.includes('test')) return faFlagCheckered;
      if (type.includes('lectie')) return faGraduationCap; 
      if (type.includes('introducere')) return faPlay;
      if (type.includes('jumphere')) return faForwardFast; 
      if (type.includes('safebadge')) return faForwardFast; 
      if (type.includes('recapitulation')) return faForwardFast; 
      return faBookOpen; // fallback general
    };
    

    return (
      <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank-lessons"></div>

      {pageLoading && (
        <div className="welcome-screen-lesson">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}

      {loadingLesson && (
        <div className="welcome-screen-lesson">
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
  
   

    
        <div className='container-show-lessons'>
        
          <div>
            {showLessonsMain && (

            <div className='body-lessons-bc-framework'>







              <div className='line-lesson-gackground' ref={scrollerRef}>

  <div className="chapter-header-sticky-wrapper-stats">
                  <div className="statscard-sticky">
                    <StatsCard />
                  </div>
                  </div>



                


            {chapters.map((chapter, index) => (
              <div key={chapter.id} className="chapter-block">
                {/* HEADER capitol */}
             
               
               <div className="chapter-header-sticky-wrapper">
                  <div className='chapter-containercf'>
                    <div className='db-data-title-button'>
                      <p className='modul-name'>{chapter.module}</p>
                      <p className='title-modul-name'>{chapter.title}</p>
                    </div>
                    
                    <div className='button-right-chapter-cf'>
                      <img src={chaptericon} />
                    </div>
                     
            
                </div>
                </div>
                <div className="general-framework-bc-mobile"></div>

                {/* LECTII capitol */}
              <div className={`chapter-lessons-wrapper ${activeChapters[index] ? 'displaying-show-chapters' : 'displaying-none-chapters'}`}>


{chapter.lessons?.map((lesson, idx) => {
  const k = `${chapter.id}-${lesson.lesson}`;

  // verificăm dacă lecția curentă este cea selectată

const lessonIdStr = String(lesson.lesson);
const chapterIdStr = String(chapter.id);
const clickedLessonKey = `${chapterIdStr}-${lessonIdStr}`;
const currentLessonKey = floatingLesson ? `${floatingLesson.chapterId}-${floatingLesson.lessonId}` : null;
const isFirstAvailable = firstAvailableLessonKey === `${chapter.id}-${lesson.lesson}`;
const isCenterLesson = String(floatingLesson?.chapterId) === String(chapter.id) &&
                       String(floatingLesson?.lessonId) === String(lesson.lesson);



  const pattern = ['align-center-odd', 'align-left', 'align-center-even', 'align-left', 'align-center-odd', 'align-right-four', 'align-right'];
  const serpentineClass = pattern[idx % pattern.length];

  return (
    <>
    <div
      key={lesson.lesson}
      className={`serpentine-wrapper ${serpentineClass} ${isCenterLesson ? 'selected-wrapper' : ''}`}
    >
      <div
        className={`lesson-show-mainbc ${isCenterLesson ? 'selected-lesson' : ''}`}
        ref={(el) => { lessonRefs.current[k] = el; }}
      >








<div className="symbol-lesson">
  {/* 🔵 Cercul START – apare DOAR la prima lecție deblocată */}
  {isFirstAvailable && lesson.explanationType?.toLowerCase() !== 'jumphere' && (
    <div className="start-bubble-wrapper">
      <FloatingLessonBubbleCf />
    </div>
  )}

  {/* 🟢 Cercul cu iconiță – trebuie să fie mereu vizibil */}
  <div className={`costomize-icon-lesson ${isFirstAvailable ? 'glow-effectcf' : ''}`}>
    <div
 className={`align-items-lessons-inside-show-cf
  ${lesson.explanationType?.toLowerCase() === 'safebadge' ? 'no-inner-bg' : ''}
  ${lesson.explanationType?.toLowerCase() === 'recapitulation' ? 'recap-lesson' : ''}
  ${lesson.explanationType?.toLowerCase() === 'jumphere' ? 'jump-here-lesson' : ''}
`}




onClick={(event) => {
  event.stopPropagation();

  const lessonIdStr = String(lesson.lesson);
  const chapterIdStr = String(chapter.id);
  const clickedLessonKey = `${chapterIdStr}-${lessonIdStr}`;
  const currentLessonKey = floatingLesson
    ? `${floatingLesson.chapterId}-${floatingLesson.lessonId}`
    : null;

  if (lesson.explanationType?.toLowerCase() === 'jumphere') {
    handleLessonClick(chapterIdStr, lessonIdStr);
    return;
  }

  // Toggle OFF
  if (clickedLessonKey === currentLessonKey) {
    setFloatingLesson(null);
    return;
  }

  // PROTECȚIE scroll
  scrollProtectorRef.current = true;
  skipNextScrollClose.current = true;
  isUserScrolling.current = false;

  // Delay de 0ms pentru ca scrollProtector să fie activ
  setTimeout(() => {
    setFloatingLesson({
      chapterId: chapterIdStr,
      lessonId: lessonIdStr,
      title: lesson.title,
    });
  }, 0);

  setTimeout(() => {
    scrollProtectorRef.current = false;
  }, 600);
}}





    >
    {lesson.explanationType?.toLowerCase() === 'safebadge' ? (
  <img
    src={safebadge}
    alt="Safe Badge"
    className="safebadge-icon"
  />
) : lesson.explanationType?.toLowerCase() === 'recapitulation' ? (
  <img
    src={brainreview}
    alt="Recapitulare"
    className="recapitulare-icon"
  />
) : lesson.explanationType?.toLowerCase() === 'jumphere' ? (
  <FontAwesomeIcon
    icon={faForwardFast}
    className="symbol-item-lesson-jump"
    style={{ color: getLessonLeftIconColor(lesson) }}
  />
) : (
  <FontAwesomeIcon
    icon={getLessonLeftIcon(lesson)}
    className="symbol-item-lesson"
    style={{ color: getLessonLeftIconColor(lesson) }}
  />
)}



    </div>


    {lesson.explanationType?.toLowerCase() === 'jumphere' && (
  
    <FloatingLessonBubbleJump />
  
)}


  </div>

  <span className="lesson-title-right">{lesson.title}</span>
</div>


{isCenterLesson && (
  <>
    <div className="arrow-floating-cf" />

    <div ref={floatingPanelWrapperRef}>
      <div className="floating-panel-over-lesson-floating-cf" data-position={serpentineClass}>
        <div className="panel-card-floating-cf">
          <p className="lesson-title-floating-cf">{lesson.title}</p>
          <p className="lesson-subtitle-floating-cf">{lesson.explanationType}</p>

         
           
        
            <div
              className="start-lesson-btn-floating-cf"
              onClick={() => handleLessonClick(chapter.id, lesson.lesson)}
            >
              Start
            </div>
         
        </div>
      </div>
    </div>
  </>
)}






      </div>
    </div>

    {/* 🔹 Separator după fiecare 7 lecții */}
      {(idx + 1) % 7 === 0 && (
        <LessonSeparator key={`separator-${idx}`} text={`Ai parcurs ${idx + 1} lecții`} />
      )}

    </>
  );
})}






</div>

              </div>
            ))}




<div className='congratuation' ref={congratsRef}>

  <img src={road} className='road'/>
  <img src={finish} className='finish'/>

<div className='gray-line-before-share' />

  <div className='share-progress'>
    <img src={trophy} className='trophy'/>
    <div className='social-progress'>
      <FontAwesomeIcon icon={faShareNodes} /> Distribuie progresul

    </div>
    <img src={trophy} className='trophy'/>
  </div>

<div className='gray-line-before-share' />






  
</div>

             <div className='obtain-certificate'>
            <img src={diploma} alt="certificate" className="disabled-image" />
            
         
            <button className='buton-diploma'>Vezi diploma!</button>
          </div>

     
{firstAvailableLessonKey && !isActiveLessonVisible && !hideScrollButton && (

  <div
    className="scroll-to-active-lesson-fixed"
    onClick={() => {
      const el = lessonRefs.current[firstAvailableLessonKey];
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }}
    aria-label="Mergi la lecția activă"
  >
    <FontAwesomeIcon
      icon={scrollDirectionUp ? faArrowUp : faArrowDown}
      className="icon-arrow-active"
    />
  </div>
)}






              </div>


 


            </div>



             )}

            



          </div>
          
        </div>







      <div className="right-elements-componentsmenu">
        <GetProCard />
        <LeaderboardCard />
        <DailyGoalsCard />
        <FooterElements />
        <SocialElements />
      </div>





      </div>
    );
  };

export default ShowLessonsFinanciara;